/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// reactstrap components
/* eslint-disable */
import { Input } from "reactstrap";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import calenderIcon from "../assets/Calendar-Icon.svg";

import searchImage from "../assets/searchIcon.svg";

const SearchComp = () => {
  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "end",
          justifyContent: "start",
          gap: "10px",
        }}
      >
        <div
          style={{
            width: "60%",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            backgroundColor: "#00000010",
            borderRadius: "12px",
            gap: "10px",
            padding: "6px 15px",
          }}
        >
          <img src={searchImage} alt="search" />
          <Input
            style={{
              border: "none",
              backgroundColor: "transparent",
              padding: "0px",
            }}
            placeholder="Search"
          />
        </div>
        <div
          style={{
            width: "40%",
            display: "flex",
            alignItems: "center",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "start",
            }}
          >
            <label style={{ fontSize: "16px", fontWeight: "bold" }}>
              Start Date
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slots={{
                  openPickerIcon: () => (
                    <img
                      src={calenderIcon}
                      alt="calendar"
                      width="20"
                      height="20"
                    />
                  ),
                }}
                slotProps={{
                  textField: {
                    sx: {
                      fontSize: "16px",
                      borderRadius: "12px",
                      backgroundColor: "#00000010", // Custom background color
                      "& .MuiInputBase-input": {
                        fontSize: "16px",
                        color: "#333",
                        padding: "15px ",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Remove border
                        },
                        "&:hover fieldset": {
                          border: "none", // Remove hover border
                        },
                        "&.Mui-focused fieldset": {
                          border: "none", // Remove focus border
                          boxShadow: "none",
                        },
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </div>
          <div
            style={{
              width: "50%",
              display: "flex",
              flexDirection: "column",
              alignItems: "start",
              justifyContent: "start",
            }}
          >
            <label style={{ fontSize: "16px", fontWeight: "bold" }}>
              End Date
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                slots={{
                  openPickerIcon: () => (
                    <img
                      src={calenderIcon}
                      alt="calendar"
                      width="20"
                      height="20"
                    />
                  ),
                }}
                slotProps={{
                  textField: {
                    sx: {
                      fontSize: "16px",
                      borderRadius: "12px",
                      backgroundColor: "#00000010", // Custom background color
                      "& .MuiInputBase-input": {
                        fontSize: "16px",
                        color: "#333",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Remove border
                        },
                        "&:hover fieldset": {
                          border: "none", // Remove hover border
                        },
                        "&.Mui-focused fieldset": {
                          border: "none", // Remove focus border
                          boxShadow: "none",
                        },
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchComp;
